import React, { PureComponent, useEffect } from "react";
import { Input, InputGroup, InputGroupAddon, InputGroupText, Spinner } from "reactstrap";
import BarLoader from "react-spinners/BarLoader";
import { bindActionCreators } from "redux";
import * as mainCompanyActions from "../../../redux/actions/mainCompanyActions";
import { connect } from "react-redux";
import metrics from "../../../common/metrics";
import { Redirect } from "react-router-dom";
import * as BB from "../../../components/BBComponent";
import task4TeamLogo from "../../../assets/logo-siyah.png";
import notify from "devextreme/ui/notify";
import jwt_decode from "jwt-decode";
import { callAPI, callApiGet } from "../../../components/Axios";
import { AppSwitch } from "@coreui/react";
import axios from 'axios';

//const oidcConfig = {
//    onSignIn: async (user) => {

//        window.location.hash = "";
//    },
//    authority: "https://test.turkuazgo.com/im",
//    scope: "openid profile",
//    clientId: "tys",
//    responseType: "code",
//    response_mode: "query",
//    redirectUri:
//        process.env.NODE_ENV === "development"
//            ? "http://localhost:5001/callback"
//            : "",
//};


class Dogus extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loginLoading: false,
            isLoading: false,
            userEmail: "",
            userPassword: "",
            redirect: false,
            showReset: false,
            resetEmail: "",
            isFlipped: false,
            passwordVisibility: false,
            loginUser: null,
            LogoUrl: "",
            loginIdentity: false,
        };

        const token = localStorage.getItem("token");
        if (!token) return;
        if (token) {
            const user = jwt_decode(token);
            if (user && new Date(user.exp * 1000) > new Date()) {
                this.state.loginUser = user;
                this.state.redirect = true;
            }
        }

        if (!this.state.redirect) {
            this.checkUser = this.checkUser.bind(this);
            this.getMainCompanyDetail = this.getMainCompanyDetail.bind(this);

            this.getMainCompanyDetail();
            //sessionStorage.clear();
            //localStorage.clear();

        }
    }

    getMainCompanyDetail() {
        callAPI(
            callApiGet,
            "api/Login/GetMainCompanies",
            {},
            async (res) => {
                const result = res?.data;
                console.log("API sonucu:", result);
                console.log("LogoUrl:", result?.LogoUrl);
                this.setState({ LogoUrl: result.LogoUrl });
            },
            true
        );
    }

    loginWithIdentity() {
        const clientId = "tys-client";
        const redirectUri = "https://talep.dohas.com.tr/"; // Turkuaz’da tanımlı olanla aynı olmalı
        //const redirectUri = "https://talepv2test.fw.dohas.com.tr/";


        const authUrl =
            `https://www.turkuazgo.com/iam/realms/prod/protocol/openid-connect/auth` +
            `?client_id=${clientId}` +
            `&response_type=code` +
            `&scope=openid` +
            `&redirect_uri=${encodeURIComponent(redirectUri)}`;
        //const authUrl =
        //    `https://test.turkuazgo.com/iam/realms/test/protocol/openid-connect/auth` +
        //    `?client_id=${clientId}` +
        //    `&response_type=code` +
        //    `&scope=openid` +
        //    `&redirect_uri=${encodeURIComponent(redirectUri)}`;

        window.location.href = authUrl;
    }


    checkUser(e) {
        const { userEmail, userPassword } = this.state;
        const isLdapLogin = false;
        const url =
            "api/Login/checkUserLogin?userName=" +
            userEmail +
            "&userPassword=" +
            userPassword +
            "&isLdapLogin=" +
            isLdapLogin;
        this.setState({ loginLoading: true });
        fetch(url)
            .then((res) => res.json())
            .then((response) => {
                if (response.Token !== undefined && response.Token !== "") {
                    localStorage.setItem("token", response.Token);
                    this.setState({ isLoading: false, redirect: true, loginLoading: false });
                    // this.props.actions.getPoolCount().then(() => {
                    //    this.setState({ isLoading: false, redirect: true });
                    // })
                } else {
                    this.setState({ isLoading: false, redirect: false, loginLoading: false });
                    notify("Kullanıcı Adı Veya Şifre Hatalı.", "error", 3000);
                }
            })
            .catch((error) => {
                this.setState({ isLoading: false, redirect: false, loginLoading: false });
                if (error) {
                    this.setState({ isLoading: false, redirect: false, loginLoading: false });
                    notify(error.response?.data, "error", 3000);
                } else {
                    this.setState({ isLoading: false, redirect: false, loginLoading: false });
                    notify("İnternet Baglantınızı Kontrol Ediniz.", "error", 3000);
                }
            });
        e.preventDefault();
    }

    forgotPasswordUser() {
        const { resetEmail } = this.state;
        if (resetEmail) {
            this.setState({ isLoading: true });
            let url = "api/Login/ForgotPassword?Email=" + this.state.resetEmail;
            BB.FetchJSON(url).then((data) => {
                alert(data);
                this.setState({ info: data, isLoading: false, showReset: false });
            });
        } else {
            notify("E-mail adresi boş bırakılamaz.", "warning", 3000);
        }
    }
    samlLogin() {
        window.location.href = 'api/Login/SamlLogin';
    }

    checksamlLogin() {
        const token = this.getHashParameter("samlToken");
        if (token) {
            localStorage.setItem("token", token);
            this.setState({ isLoading: false, redirect: true, loginLoading: false });
        }
    }

    getHashParameter(paramName) {
        const hash = window.location.hash;
        const hashParams = new URLSearchParams(hash.split('?')[1]);
        return hashParams.get(paramName);
    }
    exchangeCode = async (code) => {
        try {
            const res = await axios.post(
                "https://talep.dohas.com.tr/api/Login/TurkuazTokenExchange",
                { code }
            );
            //const res = await axios.post(
            //    "https://talepv2test.fw.dohas.com.tr/api/Login/TurkuazTokenExchange",
            //    { code }
            //);
            // 1️⃣ Turkuaz’dan gelen access_token’ı al
            const accessToken = res?.data?.access_token;

            if (!accessToken) {
                notify("Turkuaz token alınamadı", "error", 3000);
                return;
            }

            // 2️⃣ Şimdi backend'e gönder → sistem token üret
            const loginRes = await axios.post(
                "https://talep.dohas.com.tr/api/Login/TurkuazOidcLogin",
                { token: accessToken }
            );
            //const loginRes = await axios.post(
            //    "https://talepv2test.fw.dohas.com.tr/api/Login/TurkuazOidcLogin",
            //    { token: accessToken }
            //);


            const systemToken = loginRes?.data?.Token;

            if (!systemToken) {
                notify("Yetkilendirme başarısız", "error", 3000);
                return;
            }

            // 3️⃣ Sistemin token'ını sakla
            localStorage.setItem("token", systemToken);
            //sessionStorage.removeItem("oidc_code_used");
            // HASH ROUTER İÇİN
            /*window.location.href = "/#/main";*/

            //// 4️⃣ URL temizle + uygulamayı ayağa kaldır
            window.location.replace("/#/main");

            //window.location.reload();
            //this.setState({ redirect: true });


        } catch (err) {
            notify("Turkuaz token doğrulama başarısız", "error", 3000);
            console.error(err);
        }
    };



    componentDidMount() {
        this.checksamlLogin();
        const url = window.location.href;
        this.getMainCompanyDetail();
        const code = this.getCodeFromUrl();
        console.log("Alınan code:", code);

        if (code && !sessionStorage.getItem("oidc_code_used")) {
            this.exchangeCode(code);
        }
    }
    getCodeFromUrl = () => {
        // 1️⃣ Query string kontrolü
        const searchParams = new URLSearchParams(window.location.search);
        const codeFromQuery = searchParams.get("code");
        if (codeFromQuery) return codeFromQuery;

        // 2️⃣ Hash içinden kontrol (örn: #!/login?code=...)
        const hash = window.location.hash;
        const hashParamsString = hash.split('?')[1]; // hash içindeki query
        if (hashParamsString) {
            const hashParams = new URLSearchParams(hashParamsString);
            const codeFromHash = hashParams.get("code");
            if (codeFromHash) return codeFromHash;
        }

        return null;
    };


    //samlLogin = async () => {
    //    try {
    //        const response = window.open('api/Login/SamlLogin', '_self');

    //        if (response.redirected) {
    //            // Kullanıcıyı yeniden yönlendirin
    //            window.location.href = response.url;
    //        } else {
    //            const data = await response.json();
    //            console.log("API yanıtı:", data);
    //            // Yanıtı işle
    //        }
    //    } catch (error) {
    //        console.error("Hata:", error);
    //    }
    //};


    handleChange = (e) => {
        e.preventDefault();
        this.setState((prevState) => ({ isFlipped: !prevState.isFlipped }));
    };

    render() {
        const { isFlipped, redirect, isLoading, LogoUrl, passwordVisibility, loginIdentity, loginLoading } = this.state
        if (isLoading) {
            return (
                <div className="vh-100 d-flex justify-content-center align-items-center">
                    <Spinner />
                    <span className="ml-2">Giriş yapılıyor...</span>
                </div>
            );
        }
        if (redirect === true) {
            if (metrics.redirectURL !== undefined) {
                if (!metrics.redirectURL === "/") {
                    return <Redirect push to={metrics.redirectURL} />;
                }
                return <Redirect push to="/main" />;
            } else {
                return <Redirect push to="/main" />;
            }
        }


        return (
            <div className="custom-login-page">
                <div className="sweet-loading">
                    <BarLoader
                        width={"auto"}
                        size={10}
                        color={"#24364a"}
                        loading={isLoading}
                    />
                </div>
                <div className="pt-5 pb-3 d-flex justify-content-center">
                    <img
                        className="custom-dogus-logo"
                        src={LogoUrl}
                        alt="Task4Team Logo"
                    />
                </div>
                <div id="login-container" className="custom-login-form">
                    {
                        !isFlipped ? (
                            <div id="login-form">
                                <h2 className="heading" style={{ fontSize: 28 }}>
                                    Talep Yönetim Sistemi
                                </h2>
                                <p className="info-text">
                                    Turkuaz kullanıcı adınız ile giriş yapabilirsiniz.
                                </p>
                                <form onSubmit={(e) => this.checkUser(e)}>
                                    <fieldset className="p-0">
                                        <div className="_control-group">
                                            <div className="_controls">
                                                <Input
                                                    onChange={(event) =>
                                                        this.setState({ userEmail: event.target.value })
                                                    }
                                                    value={this.state.userEmail || ""}
                                                    className="required _special"
                                                    id="UserName"
                                                    name="UserName"
                                                    placeholder="Kullanıcı adı veya E-posta adresiniz"
                                                    size="30"
                                                    type="text"
                                                />
                                            </div>
                                        </div>
                                        <div className="control-group">
                                            <div className="controls">
                                                <InputGroup>
                                                    <Input
                                                        onChange={(event) =>
                                                            this.setState({
                                                                userPassword: event.target.value,
                                                            })
                                                        }
                                                        value={this.state.userPassword || ""}
                                                        className="_special"
                                                        id="Password"
                                                        name="Password"
                                                        placeholder="Şifre"
                                                        size="30"
                                                        type={
                                                            passwordVisibility
                                                                ? "text"
                                                                : "password"
                                                        }
                                                        autoComplete="off"
                                                        style={{ height: 40 }}
                                                    />
                                                    <InputGroupAddon
                                                        addonType="prepend"
                                                        className="login-password-right"
                                                    >
                                                        <InputGroupText
                                                            className="custom-password-display"
                                                            onClick={(e) =>
                                                                this.setState({
                                                                    passwordVisibility:
                                                                        !this.state.passwordVisibility,
                                                                })
                                                            }
                                                        >
                                                            <i
                                                                className={
                                                                    passwordVisibility
                                                                        ? "fa fa-eye"
                                                                        : "fa fa-eye-slash"
                                                                }
                                                            />
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <br></br>
                                        <div className="d-flex align-items-center mb-3">
                                            <label className="checkbox mb-0 mr-1"> Turkuaz Login</label>
                                            <AppSwitch
                                                onChange={() => {
                                                    this.loginWithIdentity();
                                                }}
                                                className={"float-left"}
                                                variant={"pill"}
                                                label
                                                checked={this.loginIdentity}
                                                color={"success"}
                                                size={"sm"}
                                            />
                                        </div>


                                        <div className="_control-group forgot-pass-container mt-0">
                                            <div className="_controls clearfix">
                                                <label className="checkbox pull-left"></label>
                                                <div className="pull-right">
                                                    <a
                                                        id="forgot_password"
                                                        onClick={(e) => this.handleChange(e)}
                                                        data-toggle-dom="#forgot-form, #login-form"
                                                        className="custom-forgot-password"
                                                    >
                                                        Şifremi unuttum?
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="_control-group login-form-submit">
                                            <div className="_controls">
                                                <button
                                                    type={loginLoading ? 'button' : 'submit'}
                                                    className="btn btn-primary btn-login custom-btn-login"
                                                    style={{ backgroundColor: "inherit", width: "100%" }}
                                                >
                                                    {
                                                        loginLoading ? (
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                color="light"
                                                            />
                                                        ) : ('Giriş Yap')
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    </fieldset>
                                </form>
                                <button
                                    className="btn btn-primary btn-login custom-btn-login"
                                    style={{
                                        backgroundColor: "inherit",
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}

                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.samlLogin();
                                    }}
                                >
                                    <span >Tekil Oturum Açma ile Giriş</span>
                                </button>
                            </div>) : (
                            <div>
                                <h2 className="heading" style={{ fontSize: 28 }}>
                                    Şifremi Unuttum
                                </h2>
                                <p>
                                    Şifrenizi sıfırlamak için kullanıcı adınızı yazınız. Kullanıcı
                                    adınızı bilmiyorsanız (262) 676 76 75 Turkuaz Destek Hattı ile
                                    görüşebilirsiniz.
                                </p>
                                <fieldset className="p-0">
                                    <div className="control-group forgot-form-input">
                                        <div className="controls">
                                            <Input
                                                onChange={(event) =>
                                                    this.setState({ resetEmail: event.target.value })
                                                }
                                                type="text"
                                                name="email"
                                                id="email"
                                                className="required _special"
                                                placeholder="Kullanıcı adınızı giriniz..."
                                                aria-required="true"
                                            />
                                        </div>
                                    </div>
                                </fieldset>

                                <div
                                    className="control-group button-container d-flex justify-content-end"
                                    style={{ marginTop: 16 }}
                                >
                                    <button
                                        onClick={(e) => this.handleChange(e)}
                                        type="button"
                                        data-toggle-dom="#login-form, #forgot-form"
                                        className="btn custom-reset-buttons custom-cancel-btn"
                                        id="reset-password-cancel"
                                        style={{ marginRight: 8 }}
                                    >
                                        {" "}
                                        İptal
                                    </button>
                                    <button
                                        style={{ marginRight: 0 }}
                                        onClick={() => this.forgotPasswordUser()}
                                        type="submit"
                                        className="btn custom-reset-buttons custom-reset-pass-btn"
                                        id="reset-password-submit"
                                    >
                                        Şifremi yenile
                                    </button>
                                </div>
                            </div>)
                    }
                </div>
                <div className="px-3 py-2 d-flex justify-content-end align-items-end fixed-bottom">
                    <div>
                        <img
                            className="custom-t4t-logo"
                            src={task4TeamLogo}
                            alt="TaskForTeam Logo"
                        />
                        <br></br>
                        <span className="ml-auto">
                            {" "}
                            <i className="fa fa-phone" aria-hidden="true"></i> Destek Hattı
                            : (0262) 676 76 75){" "}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        loginUser: state.loginReducer,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            getMainCompany: bindActionCreators(
                mainCompanyActions.getMainCompanyDetail,
                dispatch
            ),
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dogus);
